const options = {
  5: "bg-indigo-600/5",
  10: "bg-indigo-600/10",
  25: "bg-indigo-600/25",
  50: "bg-indigo-600/50",
  75: "bg-indigo-600/75",
  90: "bg-indigo-600/90",
  100: "bg-indigo-600",
};

const from = {
  5: "from-indigo-600/5",
  10: "from-indigo-600/10",
  25: "from-indigo-600/25",
  50: "from-indigo-600/50",
  75: "from-indigo-600/75",
  90: "from-indigo-600/90",
  100: "from-indigo-600",
};

export default function getBackgroundIndigo600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
  